module.exports = __webpack_public_path__ + "static/media/SmallCustomer.e2cb9e18.svg";